import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const MarketplaceFilters = ({ 
  filters, 
  onFilterChange, 
  onClearFilters,
  locationOptions,
  categoryOptions,
  conditionOptions,
  priceRanges 
}) => {
  const handleInputChange = (field, value) => {
    onFilterChange({ ...filters, [field]: value });
  };

  const hasActiveFilters = filters?.category || filters?.condition || filters?.location || 
                          filters?.minPrice || filters?.maxPrice || filters?.search;

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 shadow-organic border border-border">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <h2 className="text-lg md:text-xl font-semibold text-foreground flex items-center gap-2">
          <Icon name="SlidersHorizontal" size={20} className="text-primary" />
          Filtreler
        </h2>
        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearFilters}
            iconName="X"
            iconPosition="left"
            iconSize={16}
          >
            Temizle
          </Button>
        )}
      </div>
      <div className="space-y-4">
        <Input
          type="search"
          placeholder="Ürün ara..."
          value={filters?.search}
          onChange={(e) => handleInputChange('search', e?.target?.value)}
          className="w-full"
        />

        <Select
          label="Kategori"
          placeholder="Tüm kategoriler"
          options={categoryOptions}
          value={filters?.category}
          onChange={(value) => handleInputChange('category', value)}
          clearable
        />

        <Select
          label="Durum"
          placeholder="Tüm durumlar"
          options={conditionOptions}
          value={filters?.condition}
          onChange={(value) => handleInputChange('condition', value)}
          clearable
        />

        <Select
          label="Konum"
          placeholder="Tüm konumlar"
          options={locationOptions}
          value={filters?.location}
          onChange={(value) => handleInputChange('location', value)}
          searchable
          clearable
        />

        <div className="space-y-2">
          <label className="text-sm font-medium text-foreground">Fiyat Aralığı (₺)</label>
          <div className="grid grid-cols-2 gap-3">
            <Input
              type="number"
              placeholder="Min"
              value={filters?.minPrice}
              onChange={(e) => handleInputChange('minPrice', e?.target?.value)}
              min="0"
            />
            <Input
              type="number"
              placeholder="Max"
              value={filters?.maxPrice}
              onChange={(e) => handleInputChange('maxPrice', e?.target?.value)}
              min="0"
            />
          </div>
        </div>

        <div className="pt-2">
          <Button
            variant="outline"
            fullWidth
            iconName="MapPin"
            iconPosition="left"
            onClick={() => handleInputChange('nearMe', !filters?.nearMe)}
            className={filters?.nearMe ? 'border-primary text-primary' : ''}
          >
            Yakınımdaki İlanlar
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MarketplaceFilters;